import axios from "axios";
import { useMutation } from "react-query";
import {
  optimizeRequest,
  reoptimizeRequest,
  advancedOptimizeRequest,
} from "../models";
// import { manifest } from "../models";
// import { sortManifestLine } from "../utils";

const API_PATH = "Delivery/";

export const useOptimizeRequest = () =>
  useMutation((data: optimizeRequest) =>
    axios
      .post(`${API_PATH}Optimize`, {
        ...data,
      })
      .then((res) => {
        if (res.data.errorMessage) {
          return res.data;
        }
        return res?.data?.data;
      })
      .catch((reason) => Promise.reject(reason.response))
  );

export const useFetchOptimizeByJobId = () =>
  useMutation((jobId: string) =>
    axios
      .get(`${API_PATH}Optimize`, {
        params: { jobId },
      })
      .then((res) => {
        if (res.data.errorMessage) {
          return res.data;
        }
        return res?.data?.data;
      })
      .catch((reason) => Promise.reject(reason.response))
  );

export const useSubmitOptimizeRoutes = () =>
  useMutation((data: any) =>
    axios
      .post(`${API_PATH}ApplyOptimize`, data)
      .then((res) => {
        if (res.data.errorMessage) {
          return res.data;
        }

        return res?.data?.data;
      })
      .catch((reason) => Promise.reject(reason.response))
  );

export const useApplyOptimize = () =>
  useMutation((data: { date: string; routeId: string }) =>
    axios
      .post(`${API_PATH}ApplyOptimize`, {
        ...data,
      })
      .then((res) => {
        if (res.data.errorMessage) {
          return res.data;
        }
        return res?.data?.data;
      })
      .catch((reason) => Promise.reject(reason.response))
  );

export const useReoptimize = () =>
  useMutation((data: reoptimizeRequest) =>
    axios
      .post(`${API_PATH}Reoptimize`, data)
      .then((res) => {
        if (res.data.errorMessage) {
          return res.data;
        }
        return res?.data?.data;
      })
      .catch((reason) => Promise.reject(reason.response))
  );

export const useAdvancedOptimize = () =>
  useMutation((data: advancedOptimizeRequest) =>
    axios
      .post(`${API_PATH}AdvancedOptimize`, data)
      .then((res) => {
        if (res.data.errorMessage) {
          return res.data;
        }
        return res?.data?.data;
      })
      .catch((reason) => Promise.reject(reason.response))
  );
